import Logo from '../../../assets/images/utility-icons/info.svg?react';

type InformationTooltipProps = {
  title: string;
  text: string;
  optionalText?: string;
};

export const InformationTooltip = ({ title, text, optionalText }: InformationTooltipProps) => {
  return (
    <div
      style={{
        width: '320px',
        borderRadius: '6px',
        background: '#333333',
        padding: '15px',
        color: '#fff',
        display: 'flex',
        flexFlow: 'column nowrap'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        }}
      >
        <Logo fill={'rgba(255, 255, 255, 0.6)'} />
        <h4 style={{ margin: '0 0 0 10px' }}>{title}</h4>
      </div>
      <p style={{ fontSize: '14px', fontWeight: 'normal' }}>{text}</p>
      {optionalText !== undefined ? <p style={{ fontSize: '14px', fontWeight: 'normal' }}>{optionalText}</p> : ''}
    </div>
  );
};
